// Kuala Lumpur / Klang Valley locality copy for
// /my/aircond-service-kuala-lumpur/locality/<slug>. paragraphs[0] is the lead.
// Each entry is written for its own area - no shared sentences.

const localities = {
    'mont-kiara': {
        paragraphs: [
            'Aircond service for Mont Kiara condos - general service, chemical wash and gas top up at fixed prices.',
            'Mont Kiara is high-rise condo country, popular with expatriate families, and most units have a wall-mounted aircond in every room plus one or two in the living area. Condo management here typically wants contractor details in advance, and outdoor units sit on ledges that need safe access.',
            'Families with children and helpers often run bedroom units every night; a service every three months keeps them fresh.',
        ],
        homes: 'High-rise condominiums with wall-mounted units in each room; outdoor units on ledges.',
        watch: 'Ledge access rules - share your condo name so the technician comes prepared.',
        defaultMount: 'Wall',
    },
    bangsar: {
        paragraphs: [
            'Aircond service for Bangsar homes, from terrace houses and bungalows to condos around Bangsar South.',
            'Bangsar mixes older landed homes on hilly streets with newer condominiums. Older houses often have a ceiling cassette in the living hall and a range of wall units of different ages upstairs - which means different gas types in one house.',
            'If some rooms cool well and others don\'t, it is usually the oldest units; a chemical wash and gas check on those is the cost-effective fix.',
        ],
        homes: 'Terrace houses, semi-Ds and bungalows, plus condos in Bangsar South.',
        watch: 'Mixed-age units in one house; older R22 units losing gas.',
        defaultMount: 'Wall',
    },
    klcc: {
        paragraphs: [
            'Aircond service for KLCC condos and serviced residences, booked online with prices upfront.',
            'Residences around KLCC are mostly luxury high-rises and serviced apartments, often with strict building management and booking procedures for contractors. Units here may include ducted or cassette systems as well as wall-mounted splits.',
            'Owners of short-stay apartments in the area should service units more often - heavy use by guests clogs filters quickly.',
        ],
        homes: 'Luxury condominiums and serviced residences with wall, cassette and ducted units.',
        watch: 'Building booking rules and limited service hours - book a few days ahead.',
        defaultMount: 'Wall',
    },
    'bukit-bintang': {
        paragraphs: [
            'Aircond service for Bukit Bintang condos, serviced apartments and shops.',
            'Bukit Bintang has a high share of serviced apartments and short-stay units. Aircond in these units runs hard with changing guests, and smells or drips quickly lead to poor reviews.',
            'For hosts, a servicing package with a service every three months keeps units guest-ready and costs less per visit.',
        ],
        homes: 'Serviced apartments and condos with wall-mounted units; shops with cassettes.',
        watch: 'Musty smells in heavily used short-stay units.',
        defaultMount: 'Wall',
    },
    cheras: {
        paragraphs: [
            'Affordable aircond service for Cheras terrace houses, flats and condos.',
            'Cheras is a large, established residential area with many double-storey terraces and older flats. A lot of homes here still run older non-inverter units that work harder and collect more dirt.',
            'Servicing every unit in the house together keeps the price per unit low - useful for families with four or five units.',
        ],
        homes: 'Terrace houses, flats and newer condos; many older non-inverter wall units.',
        watch: 'Older units losing cooling power; drains blocked after long neglect.',
        defaultMount: 'Wall',
    },
    setapak: {
        paragraphs: [
            'Aircond service for Setapak homes, rental rooms and condos, with fixed prices.',
            'Setapak has many student rentals and flats around its colleges, along with terrace houses and newer condos. Room rental units often run every night and are rarely serviced between tenants.',
            'Landlords with several rooms can book all units in one visit and keep a record for each tenancy.',
        ],
        homes: 'Flats, terrace houses, room rentals and condos with wall-mounted units.',
        watch: 'Units not serviced between tenants - smells and drips.',
        defaultMount: 'Wall',
    },
    kepong: {
        paragraphs: [
            'Aircond service for Kepong terrace houses, flats and condos.',
            'Kepong is a mature neighbourhood of landed homes and flats in KL\'s north-west, close to the green belt of FRIM. Homes near greenery see more leaves and debris around outdoor units, which can block airflow.',
            'A yearly check of outdoor units, alongside regular indoor services, keeps compressors running cool.',
        ],
        homes: 'Terrace houses, flats and newer condos with wall-mounted units.',
        watch: 'Leaves and debris around outdoor units near green areas.',
        defaultMount: 'Wall',
    },
    'sri-petaling': {
        paragraphs: [
            'Aircond service for Sri Petaling and Bukit Jalil homes, from terrace houses to condos.',
            'Sri Petaling\'s family neighbourhoods combine landed homes with growing condo developments. Many families have several units in bedrooms and a larger unit in the living hall.',
            'Book every unit in one visit - it\'s cheaper per unit and only one morning of disruption.',
        ],
        homes: 'Terrace houses and condominiums with wall-mounted units; some living-hall cassettes.',
        watch: 'Living-hall units struggling on hot afternoons.',
        defaultMount: 'Wall',
    },
    'desa-parkcity': {
        paragraphs: [
            'Aircond service for Desa ParkCity condos and landed homes.',
            'Desa ParkCity is a planned township with condominiums around the central park and landed homes at the edges. Properties are generally well-kept, and the work here is mostly regular general services and yearly chemical washes.',
            'Many residents prefer a servicing package so units are done on a regular schedule without having to book each time.',
        ],
        homes: 'Condominiums and landed homes in a planned township.',
        watch: 'Keeping to a regular schedule - a package makes it effortless.',
        defaultMount: 'Wall',
    },
    ampang: {
        paragraphs: [
            'Aircond service for Ampang bungalows, condos and apartments.',
            'Ampang ranges from large bungalows near the embassies to condos and older apartments. Bungalows can have eight or more units including ceiling cassettes in living areas, while condos have wall units in every room.',
            'For big houses, a two-visit plan works best: wall units on one day, cassettes on another.',
        ],
        homes: 'Bungalows with many units and cassettes; condos and apartments with wall units.',
        watch: 'Cassette drain pumps in living areas; many units to coordinate.',
        defaultMount: 'Wall',
    },
    sentul: {
        paragraphs: [
            'Aircond service for Sentul condos and homes, with prices shown upfront.',
            'Sentul has changed fast, with new condominium developments next to older houses and shophouses. New condo units mostly have modern inverter wall units, while older homes may still run non-inverter units.',
            'New-condo owners: the first service after handover often clears construction dust from filters and drains.',
        ],
        homes: 'New condominiums with inverter units, plus older houses and shophouses.',
        watch: 'Construction dust in new units; older units in older houses.',
        defaultMount: 'Wall',
    },
    ttdi: {
        paragraphs: [
            'Aircond service for Taman Tun Dr Ismail homes - terraces, semi-Ds and condos.',
            'TTDI is an established, leafy neighbourhood next to Bukit Kiara, with landed homes and a few condo blocks. Trees and greenery around houses mean outdoor units collect leaves and need clearing.',
            'Many TTDI homes have been renovated; if a unit was moved during works, its gas joints are worth checking.',
        ],
        homes: 'Terrace houses, semi-Ds and some condos; leafy streets.',
        watch: 'Leaves around outdoor units; gas leaks on relocated units.',
        defaultMount: 'Wall',
    },
    'damansara-heights': {
        paragraphs: [
            'Aircond service for Damansara Heights bungalows and condos.',
            'Damansara Heights is known for large bungalows on hillside plots, many with ceiling cassettes or ducted systems in living areas alongside wall units in bedrooms. These bigger systems need more time per unit and careful work at height.',
            'Tell us the mix of units when booking so we can send the right team and allow enough time.',
        ],
        homes: 'Large bungalows with cassettes or ducted systems, plus some condos.',
        watch: 'Cassette drain pumps and larger units that need more service time.',
        defaultMount: 'Ceiling',
    },
    brickfields: {
        paragraphs: [
            'Aircond service for Brickfields apartments, shophouses and businesses.',
            'Brickfields, KL\'s Little India near KL Sentral, mixes older shophouses and apartments with newer condos. Shops and restaurants here run aircond long hours, and kitchen grease and street dust build up quickly.',
            'Businesses benefit from a service every two to three months; homes every three to four.',
        ],
        homes: 'Shophouses, older apartments and newer condos; shops with cassettes.',
        watch: 'Grease and dust build-up in shops and restaurants.',
        defaultMount: 'Wall',
    },
    'wangsa-maju': {
        paragraphs: [
            'Aircond service for Wangsa Maju flats, terraces and condos.',
            'Wangsa Maju is a family area of flats and terrace houses with good LRT access. Many households have two or three wall units, often running every night.',
            'Servicing all units together is the cheapest way to keep a family home cool.',
        ],
        homes: 'Flats, apartments and terrace houses with wall-mounted units.',
        watch: 'Units running nightly that go too long between services.',
        defaultMount: 'Wall',
    },
    'old-klang-road': {
        paragraphs: [
            'Aircond service for homes along Old Klang Road - condos, apartments and landed homes.',
            'Old Klang Road has many mid-range condos and apartments plus older landed homes, and heavy traffic along the main road brings plenty of dust. Filters in homes facing the road clog quickly.',
            'Rinse filters every two weeks if your unit faces the road, and book a chemical wash once a year.',
        ],
        homes: 'Condos, apartments and older landed homes; busy main road.',
        watch: 'Traffic dust clogging filters and coils.',
        defaultMount: 'Wall',
    },
    'petaling-jaya': {
        paragraphs: [
            'Aircond service across Petaling Jaya - from SS2 and Damansara Utama to Kelana Jaya and Section 17.',
            'PJ has a huge mix of housing: older terraces in the established sections, condos near the LRT lines and offices around the business districts. Older terraces often have a cassette in the hall and wall units of different ages upstairs.',
            'We cover all of PJ at the same prices as KL, with no extra transport charge.',
        ],
        homes: 'Terrace houses, semi-Ds, condos and offices across many sections.',
        watch: 'Mixed-age units in older terraces; cassettes in living halls.',
        defaultMount: 'Wall',
    },
    'subang-jaya': {
        paragraphs: [
            'Aircond service for Subang Jaya homes - SS15, USJ and around - at KL prices.',
            'Subang Jaya has dense terrace neighbourhoods, condos and a large student population near its colleges. Student rentals and family homes alike run units for long hours.',
            'Landlords of student rooms can book all units together and keep each room\'s service on record.',
        ],
        homes: 'Terrace houses, condos and student rentals with wall-mounted units.',
        watch: 'Rentals going years without service; drips and smells.',
        defaultMount: 'Wall',
    },
}

export default localities
